<script setup></script>

<template>
  <h1 class="section-title">Spreading Sunshine: My Passion for People and Positivity</h1>
  <img
    src="/images/ashley-friel-blog-post-2.jpg"
    alt="Ashley Friel Blog Post 1 Image"
    style="width: 100%; aspect-ratio: 2/1; object-fit: cover; object-position: center 15%"
    class="mt-4 w-100 rounded-4"
  />

  <h3 class="h5 mt-4 mb-0">The Power of Positivity: My Secret Sauce</h3>
  <p class="section-text mt-1">
    Positivity has always been one of my defining traits. Yes, even with a busy work schedule, a tough day at school, or
    a battle in team sports, I believe that exchanging a few optimistic words may turn the tide really quickly. The
    positive energy makes me feel better instantly, and at the same time, it encourages everyone around me. Walk into a
    room with a shine, and I can see the ripple effect it creates. It's my always-on secret sauce for creating an
    incredible vibe, and I wouldn't have it any other way!
  </p>

  <h3 class="h5 mb-0">Why People Are at the Heart of Everything I Do</h3>
  <p class="section-text mt-1">
    For as long as I can remember, I have always been a people person. Be it hanging out with friends, being on a sports
    team, or collaborating at work; the human interaction really puts the icing on the cake for me. Hence, careers where
    you are talking to people and trying to connect with them and develop them have always sparked my interest. My
    volunteer service in coaching has brought me this far, and my dreams for a career in business all point to my shared
    passion for bringing people together and ensuring that everyone gets to be heard in that.
  </p>

  <h3 class="h5 mb-0">Creating Connections with a Personal Touch</h3>
  <p class="section-text mt-1">
    In all aspects of my life, whether volunteer projects or clear career goals, I always try to create deeper
    connections with the people involved. Being a friendly and understanding person has earned me the trust of my
    friends, colleagues, and bosses. The little things — checking on team members or helping a team member — build that
    foundation of trust, collaboration, and cooperation. I live for creating connections, and I hope to foster them in
    all my future endeavors.
  </p>

  <h3 class="h5 mb-0">The Road Ahead: Bringing Positivity to the Workplace</h3>
  <p class="section-text mt-1 mb-0">
    I'm really looking forward to continuing my spread of positivity and fostering genuine connections. Be it HR,
    customer engagement, or any other people-oriented position, I believe that my prime value will always be my
    commitment to uplifting others. This road has just started, and I'm awaiting the wondrous lengths that a little
    sunshine can travel!
  </p>
</template>

<style lang="scss" scoped></style>
